import ReactGA from 'react-ga4';
import { gAnalytics } from '../Constants/Constants';

let isGAInitialized = false;

const isDevelopment = process.env.NODE_ENV === 'development';

export const initializeGAWithConsent = () => {
  if (isGAInitialized) {
    return;
  }

  if (typeof window.CookieConsent !== 'undefined') {
    const analyticsCategory = window.CookieConsent.config.categories.analytics;
    if (isDevelopment) {
      console.log('Checking GA initialization consent:', {
        analyticsCategory: analyticsCategory,
        wanted: analyticsCategory ? analyticsCategory.wanted : 'undefined',
        gaTrackingId: gAnalytics.googleAnalyticsTrackingId,
        environment: gAnalytics.mode,
      });
    }

    if (analyticsCategory && analyticsCategory.wanted === true) {
      const gaTrackingId = gAnalytics.googleAnalyticsTrackingId;
      ReactGA.initialize(gaTrackingId, {
        debug: isDevelopment,
        gtagOptions: {
          debug_mode: isDevelopment,
          send_page_view: false,
        },
      });

      if (!isDevelopment) {
        const originalConsoleLog = console.log;
        console.log = function (...args) {
          const message = args[0];
          if (
            typeof message === 'string' &&
            (message.includes('Processing commands') ||
              message.includes('gtag') ||
              message.includes('Google Analytics'))
          ) {
            return;
          }
          originalConsoleLog.apply(console, args);
        };
      }
      isGAInitialized = true;
    }
  }
};

export const sendGAEvent = eventData => {
  if (typeof window.CookieConsent !== 'undefined') {
    const analyticsCategory = window.CookieConsent.config.categories.analytics;
    if (analyticsCategory && analyticsCategory.wanted === true) {
      if (!isGAInitialized) {
        initializeGAWithConsent();
      }
      if (isGAInitialized) {
        ReactGA.event(eventData);
      }
    }
  }
};

export const sendGAPageview = pageData => {
  if (typeof window.CookieConsent !== 'undefined') {
    const analyticsCategory = window.CookieConsent.config.categories.analytics;
    if (analyticsCategory && analyticsCategory.wanted === true) {
      if (!isGAInitialized) {
        initializeGAWithConsent();
      }
      if (isGAInitialized) {
        ReactGA.send(pageData);
      }
    }
  }
};

export const hasAnalyticsConsent = () => {
  if (typeof window.CookieConsent !== 'undefined') {
    const analyticsCategory = window.CookieConsent.config.categories.analytics;
    return analyticsCategory && analyticsCategory.wanted === true;
  }
  return false;
};

export const setupConsentListener = () => {
  const checkAndSetupListener = () => {
    if (typeof window.CookieConsent !== 'undefined') {
      const analyticsCategory = window.CookieConsent.config.categories.analytics;

      if (analyticsCategory && analyticsCategory.wanted === true) {
        initializeGAWithConsent();
      }

      document.addEventListener('click', event => {
        const target = event.target;

        if (
          target.classList.contains('consent-give') ||
          target.classList.contains('ccm__footer') ||
          target.textContent.includes('Accept all cookies') ||
          target.textContent.includes('Save current settings')
        ) {
          setTimeout(() => {
            initializeGAWithConsent();
          }, 200);
        }
      });
    } else {
      setTimeout(checkAndSetupListener, 100);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndSetupListener);
  } else {
    checkAndSetupListener();
  }
};

export const clearConsentCookies = () => {
  const cookies = document.cookie.split(';');
  cookies.forEach(cookie => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
    if (name.includes('consent') || name.includes('cookie') || name.includes('_ga')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
    }
  });

  Object.keys(localStorage).forEach(key => {
    if (key.includes('consent') || key.includes('cookie')) {
      localStorage.removeItem(key);
    }
  });
};

if (typeof window !== 'undefined') {
  window.clearConsentCookies = clearConsentCookies;
  window.checkGAStatus = () => {
    console.log('GA Status:', {
      isInitialized: isGAInitialized,
      hasConsent: hasAnalyticsConsent(),
      gaConfig: gAnalytics,
      cookieConsentAvailable: typeof window.CookieConsent !== 'undefined',
    });
  };
}
